const withRedux: boolean = false;
const alertAutoHideDuration: number = 3000;
const newHomePage = true;

const stripeKey =
  "pk_live_51IbnKeFRzcATvsXkbCDSUZa1MZ5i5czR0Bi7fq93b52RSsJ9CzNClPWe2r6ACy26AfPWR72eyrjUb6mnlop8q3qz00TtsYXYwe";
const recaptchaKey = "6LcAqFAaAAAAABu6lvUP8NPba-pDejxG9AiMe_qR";

export { withRedux, alertAutoHideDuration, stripeKey, recaptchaKey, newHomePage };
